import i18n from "@/i18n";
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, message: String(error?.message || error) };
  }
  componentDidCatch(error, info) {
    // Surface to console for debugging — never crashes UI now.
    // eslint-disable-next-line no-console
    console.error("SUX1 ErrorBoundary caught:", error, info);
  }
  reset = () => this.setState({ hasError: false, message: "" });
  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.message, this.reset);
      }
      return (
        <div className="border border-[#002FA7] bg-[#002FA7]/5 p-6 text-sm">
          <div className="sux-marker mb-2 text-[#002FA7]">
            Un petit souci dans cette section
          </div>
          <p className="font-mono text-xs text-muted-foreground mb-3 break-words">
            {this.state.message || (i18n.language?.startsWith("en") ? "Unknown error" : "Erreur inconnue")}
          </p>
          <button
            onClick={this.reset}
            className="font-mono uppercase tracking-[0.2em] text-[11px] px-3 py-2 border border-[#002FA7] text-[#002FA7] hover:bg-[#002FA7] hover:text-white transition-colors"
          >
            {i18n.language?.startsWith("en") ? "Try again" : "Réessayer"}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
